"use client";

/**
 * Contacto 6.5 — canales (WhatsApp, correo, redes) + formulario de mensaje.
 */

import { useState } from "react";

import { BottomNav, HeaderTitulo } from "@/components/app/chrome";
import { IconoWhatsApp } from "@/components/app/iconos";

export function ContactoCliente({
  numeroWhatsapp,
  email,
  instagram,
}: {
  numeroWhatsapp: string;
  email: string;
  instagram: string;
}) {
  const [asunto, setAsunto] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [estado, setEstado] = useState<"idle" | "enviando" | "listo">("idle");
  const [error, setError] = useState<string | null>(null);

  const waHref = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(
    "Hola, tengo una pregunta sobre Frescazo.",
  )}`;

  async function enviar() {
    if (estado !== "idle") return;
    if (!asunto.trim() || !mensaje.trim()) {
      setError("Cuéntanos el asunto y el mensaje.");
      return;
    }
    setError(null);
    setEstado("enviando");
    try {
      const res = await fetch("/api/contacto", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ asunto, mensaje }),
      });
      const data = await res.json();
      if (!res.ok || !data.ok) {
        setError(data.error ?? "No pudimos enviar el mensaje.");
        setEstado("idle");
        return;
      }
      setEstado("listo");
      setAsunto("");
      setMensaje("");
      setTimeout(() => setEstado("idle"), 2000);
    } catch {
      setError("Sin conexión. Intenta de nuevo.");
      setEstado("idle");
    }
  }

  return (
    <>
      <HeaderTitulo titulo="Contacto" />
      <main className="anim-bz-in min-h-(--alto-app) px-6 pt-[100px] pb-[62px]">
        <div className="flex flex-col gap-3 pt-[22px] pb-[30px]">
          <a
            href={waHref}
            target="_blank"
            rel="noopener noreferrer"
            className="flex h-[66px] items-center gap-3 rounded-[26px] bg-lima px-[22px]"
          >
            <IconoWhatsApp size={22} color="#082411" />
            <span>
              <span className="block font-app text-base font-semibold text-bosque">
                WhatsApp
              </span>
              <span className="block text-xs text-bosque/70">
                Respondemos en minutos
              </span>
            </span>
          </a>

          <div className="flex h-[66px] items-center gap-3 rounded-[26px] border border-black/10 bg-white px-[22px]">
            <span className="h-[22px] w-[22px] rounded-md bg-humo" />
            <span>
              <span className="block font-app text-base font-semibold">{email}</span>
              <span className="block text-xs text-tinta/55">Respuesta en 24 h</span>
            </span>
          </div>

          <div className="flex h-[66px] items-center gap-3 rounded-[26px] border border-black/10 bg-white px-[22px]">
            <span className="h-[22px] w-[22px] rounded-md bg-humo" />
            <span>
              <span className="block font-app text-base font-semibold">
                @{instagram}
              </span>
              <span className="block text-xs text-tinta/55">Instagram y TikTok</span>
            </span>
          </div>

          <h2 className="mt-2 font-app text-base font-semibold">
            O déjanos un mensaje
          </h2>
          <input
            value={asunto}
            onChange={(e) => setAsunto(e.target.value)}
            placeholder="Asunto"
            className="h-[58px] rounded-[20px] border border-black/10 bg-white px-[18px] text-base outline-0 placeholder:text-tinta/40"
          />
          <textarea
            value={mensaje}
            onChange={(e) => setMensaje(e.target.value)}
            placeholder="Cuéntanos qué pasó"
            className="h-[120px] resize-none rounded-[20px] border border-black/10 bg-white px-[18px] py-4 font-sans text-base outline-0 placeholder:text-tinta/40"
          />
          {error && <p className="text-sm text-[#B4463A]">{error}</p>}
          <button
            type="button"
            onClick={() => void enviar()}
            disabled={estado === "enviando"}
            className="flex h-[62px] items-center justify-center rounded-[30px] bg-verde font-app text-[17px] font-semibold text-white transition active:scale-[.98] disabled:opacity-60"
          >
            {estado === "listo"
              ? "¡Mensaje enviado!"
              : estado === "enviando"
                ? "Enviando…"
                : "Enviar"}
          </button>

          <div className="rounded-[20px] bg-humo p-4 text-[13px] leading-[19px] text-tinta/65">
            Cocina y punto de retiro: Vía a Nayón, Cumbayá. Lun a sáb, 8 am – 6 pm.
          </div>
        </div>
      </main>
      <BottomNav />
    </>
  );
}
